import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import React from "react";
import { useTranslation } from "react-i18next";
interface IProps {
  open: boolean;
  confirmText?: string;
  handleClose: () => void;
  handleSubmit: () => void;
}

const ConfirmModal = ({
  open,
  confirmText,
  handleClose,
  handleSubmit,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        className={"MuiModalBody"}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: { xs: "80%", lg: "30%" },
        }}
      >
        <Typography id="modal-modal-title" variant="h5">
          {t("general.confirmTitle")}
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{ my: 3, textAlign: "center" }}
          component={"p"}
        >
          {confirmText}
        </Typography>
        <div>
          <Button
            variant={"contained"}
            color={"secondary"}
            size={"small"}
            onClick={handleClose}
            sx={{ marginRight: "10px" }}
          >
            {t("button.cancel")}
          </Button>
          <Button variant={"contained"} size={"small"} onClick={handleSubmit}>
            {t("button.yesConfirm")}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
export default ConfirmModal;
